import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { ApiError } from "./lib/api.ts";
import { fetchOperator, SessionProvider } from "./lib/session.tsx";
import { BrandProvider } from "./lib/brand.tsx";
import { createAppRouter } from "./router.tsx";
import { FatalScreen } from "./components/app/fatal-screen.tsx";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: 0 },
  },
});

async function boot() {
  const root = createRoot(document.getElementById("root")!);
  try {
    const operator = await queryClient.fetchQuery({ queryKey: ["operator"], queryFn: fetchOperator, staleTime: 5 * 60_000 });
    const router = createAppRouter(queryClient, operator);
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrandProvider operator={operator}>
            <SessionProvider operator={operator}>
              <RouterProvider router={router} />
              <Toaster richColors closeButton position="bottom-right" toastOptions={{ className: "font-sans" }} />
            </SessionProvider>
          </BrandProvider>
        </QueryClientProvider>
      </StrictMode>,
    );
  } catch (e) {
    root.render(<FatalScreen error={e} />);
  }
}

void boot();
